export type AnalyticsValue = string | number | boolean;
export type AnalyticsProperties = Record<string, AnalyticsValue>;

type UmamiWindow = Window & {
  umami?: {
    track: (event: string, properties?: AnalyticsProperties) => void;
  };
};

/**
 * Privacy-safe, best-effort custom analytics. Callers must only pass
 * low-cardinality enums, booleans, or counts—never user-authored content or IDs.
 */
export function trackEvent(event: string, properties?: AnalyticsProperties): void {
  try {
    if (typeof window === 'undefined') return;
    (window as UmamiWindow).umami?.track(event, properties);
  } catch {
    // Analytics must never affect the product experience.
  }
}